import { render } from "./windzxsh.vue?vue&type=template&id=29da766f"
import script from "./windzxsh.vue?vue&type=script&lang=js"
export * from "./windzxsh.vue?vue&type=script&lang=js"

import "./windzxsh.vue?vue&type=style&index=0&id=29da766f&lang=css"

import exportComponent from "F:\\handzone_game\\10001-sdk\\web\\hzgamebox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__